module.exports = __webpack_public_path__ + "img/15.3b81faf7.jpg";